export const FILE_NODE_SORT_OPTIONS = [
    { id: 'manual', label: 'Custom · drag to arrange' },
    { id: 'date_desc', label: 'Date · newest first' },
    { id: 'date_asc', label: 'Date · oldest first' },
    { id: 'name_asc', label: 'Name · A to Z' },
    { id: 'name_desc', label: 'Name · Z to A' },
];

const TYPE_RANK = { folder: 0, file: 1, youtube: 2 };

function nodeTimestamp(n) {
    const t = n?.createdAt || n?.updatedAt;
    const ms = t ? new Date(t).getTime() : 0;
    return Number.isFinite(ms) ? ms : 0;
}

function nodeOrder(n) {
    const o = Number(n?.order);
    return Number.isFinite(o) ? o : 999;
}

/** Sort folders and files with the same rule; folders stay grouped before files/videos. */
export function sortFileNodes(nodes, sortBy) {
    // Manual mode: honor the admin-defined drag order across ALL types
    // (no folder-before-file grouping, so anything can sit anywhere).
    if (sortBy === 'manual') {
        return [...nodes].sort((a, b) => {
            const diff = nodeOrder(a) - nodeOrder(b);
            if (diff !== 0) return diff;
            return nodeTimestamp(b) - nodeTimestamp(a);
        });
    }

    return [...nodes].sort((a, b) => {
        const typeDiff = (TYPE_RANK[a.type] ?? 9) - (TYPE_RANK[b.type] ?? 9);
        if (typeDiff !== 0) return typeDiff;

        if (sortBy === 'date_asc') return nodeTimestamp(a) - nodeTimestamp(b);
        if (sortBy === 'name_asc') return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
        if (sortBy === 'name_desc') return b.name.localeCompare(a.name, undefined, { sensitivity: 'base' });
        return nodeTimestamp(b) - nodeTimestamp(a);
    });
}
